@if (configuration()?.icon) {
  <div
    class="icon-flex"
    [ngStyle]="getTextAlignment()"
    [matTooltip]="configuration()?.title | translate"
    [matTooltipDisabled]="!configuration()?.title"
    [matTooltipPosition]="'above'">
    <icon-content [iconStyle]="iconStyle" [configuration]="configuration()"></icon-content>

    @if (!!configuration().text) {
      <span
        class="icon-text"
        [style.fontSize.rem]="configuration().textSize / 10"
        [style.lineHeight.rem]="configuration().textSize / 10"
        [style.color]="getTextColor()"
        [style.textTransform]="configuration().textTransform">
        {{ configuration().text | translate }}
      </span>
    }
    @if (!!configuration().safeHtml) {
      <span
        class="icon-text"
        [style.fontSize.rem]="configuration().textSize / 10"
        [style.lineHeight.rem]="configuration().textSize / 10"
        [style.color]="getTextColor()"
        [style.textTransform]="configuration().textTransform"
        [innerHTML]="configuration().safeHtml"></span>
    }
  </div>
}
